import { render, staticRenderFns } from "./ExchangeRecords.vue?vue&type=template&id=956a5162&scoped=true"
import script from "./ExchangeRecords.vue?vue&type=script&lang=js"
export * from "./ExchangeRecords.vue?vue&type=script&lang=js"
import style0 from "./ExchangeRecords.vue?vue&type=style&index=0&id=956a5162&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "956a5162",
  null
  
)

export default component.exports